<template>
  <g>
    <polygon points="75,425 75,75 355,75 425,425" stroke="#b1b1b1" stroke-width="1" fill="#fff" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <g v-for="(side, index) in sides" :key="index">
        <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#ddd" stroke-width="1"/>
        <polygon :points="side.border.corner.start" :transform="side.border.corner.rotateStart" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <polygon :points="side.border.corner.end" :transform="side.border.corner.rotateEnd" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <rect :x="side.labelBackground.x" :y="side.labelBackground.y" :width="side.labelBackground.width" :height="side.labelBackground.height" style="fill:#fff" />
      </g>
    </g>
    <text v-for="side in sides" :key="side.id" dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="side.labelSpace.x" :y="side.labelSpace.y" class="font-weight-bold" font-size="1em">{{side.name}}</tspan>
      <tspan v-if="formComplete" :x="side.labelSpace.x" dy="1.5em" font-size="0.7em">{{side.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="side.labelSpace.x" dy="1em" font-size="0.7em">{{side.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === rand.saum.titleSaum.name">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="activeOesenArt">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === rand.hohlsaum.title.name" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
        <g v-if="side.rand === rand.keder.title.name" stroke="#b1b1b1" stroke-opacity="0">
          <polygon :points="side.keder.outside" fill="#b1b1b1"/>
          <polygon :points="side.keder.inside" fill="#8e8e8e"/>
        </g>
      </g>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt
    }
  },
  methods: {
    spaceRand (x, y) {
      return (Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2)))
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            xStart: 90,
            xEnd: 422 - Math.sqrt(Math.pow(3, 2) + Math.pow(15, 2)),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 410
            }
          },
          saum: 'M75 395 L419 395',
          hohlsaum: 'M75 416 L' + (425 - 9 / 5) + ' 416',
          keder: {
            outside: '75,425 425,425 ' + (425 - 9 / 5) + ',416 75,416',
            inside: '75,425 425,425 ' + (425 - 3 / 5) + ',422 75,422'
          },
          labelSpace: {
            x: 250,
            y: 455
          },
          labelBackground: {
            x: 215,
            y: 437,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 75,
              yStart: 465,
              xEnd: 425,
              yEnd: 465
            },
            corner: {
              start: '75,465 85,460 85,470',
              rotateStart: 'rotate(0, 75, 465)',
              end: '425,465 415,460 415,470',
              rotateEnd: 'rotate(0, 425, 465)'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          size: Math.round(this.calcSides[1]),
          rand: this.randSides[1].type.name,
          oesenAnzahl: this.randSides[1].oesenAnzahl,
          oesenAbstand: {
            xStart: 90,
            yStart: 410,
            yEnd: 90,
            x: function (i, item) {
              return this.xStart
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } else if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M105 75 L105 425',
          hohlsaum: 'M84 75 L84 425',
          keder: {
            outside: '75,425 84,425 84,75 75,75',
            inside: '75,425 78,425 78,75 75,75'
          },
          labelSpace: {
            x: 35,
            y: 250
          },
          labelBackground: {
            x: 0,
            y: 231,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 35,
              yStart: 75,
              xEnd: 35,
              yEnd: 425
            },
            corner: {
              start: '35,75 30,85 40,85',
              rotateStart: 'rotate(0, 35, 75)',
              end: '35,425 30,415 40,415',
              rotateEnd: 'rotate(0, 35, 425)'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          size: Math.round(this.calcSides[2]),
          rand: this.randSides[2].type.name,
          oesenAnzahl: this.randSides[2].oesenAnzahl,
          oesenAbstand: {
            xStart: 90,
            xEnd: 358 - Math.sqrt(Math.pow(3, 2) + Math.pow(15, 2)),
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              return 90
            }
          },
          saum: 'M75 105 L361 105',
          hohlsaum: 'M75 84 L' + (355 + 9 / 5) + ' 84',
          keder: {
            outside: '75,75 355,75 ' + (355 + 9 / 5) + ',84 75,84',
            inside: '75,75 355,75 ' + (355 + 3 / 5) + ',78 75,78'
          },
          labelSpace: {
            x: 215,
            y: 27
          },
          labelBackground: {
            x: 180,
            y: 10,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 75,
              yStart: 35,
              xEnd: 355,
              yEnd: 35
            },
            corner: {
              start: '75,35 85,30 85,40',
              rotateStart: 'rotate(0, 75, 35)',
              end: '355,35 345,30 345,40',
              rotateEnd: 'rotate(0, 355, 35)'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          size: Math.round(this.calcSides[3]),
          rand: this.randSides[3].type.name,
          oesenAnzahl: this.randSides[3].oesenAnzahl,
          oesenAbstand: {
            xStart: 358 - Math.sqrt(Math.pow(3, 2) + Math.pow(15, 2)),
            xEnd: 422 - Math.sqrt(Math.pow(3, 2) + Math.pow(15, 2)),
            yStart: 90,
            yEnd: 410,
            x: function (i, item) {
              if (item === 1) {
                return (this.xStart + this.xEnd) / 2
              } if (item === 2) {
                return this.xStart + i * (this.xEnd - this.xStart)
              } else {
                return this.xStart + (i / (item - 1)) * (this.xEnd - this.xStart)
              }
            },
            y: function (i, item) {
              if (item === 1) {
                return (this.yStart + this.yEnd) / 2
              } else if (item === 2) {
                return this.yStart + i * (this.yEnd - this.yStart)
              } else {
                return this.yStart + (i / (item - 1)) * (this.yEnd - this.yStart)
              }
            }
          },
          saum: 'M' + (355 - this.spaceRand(6, 30)) + ' 75 L' + (425 - this.spaceRand(6, 30)) + ' 425',
          hohlsaum: 'M' + (355 - this.spaceRand(9 / 5, 9)) + ' 75 L' + (425 - this.spaceRand(9 / 5, 9)) + ' 425',
          keder: {
            outside: (355 - this.spaceRand(9 / 5, 9)) + ',75 ' + (425 - this.spaceRand(9 / 5, 9)) + ',425 425,425 355,75',
            inside: (355 - this.spaceRand(3 / 5, 3)) + ',75 ' + (425 - this.spaceRand(3 / 5, 3)) + ',425 425,425 355,75'
          },
          labelSpace: {
            x: 440,
            y: 250
          },
          labelBackground: {
            x: 405,
            y: 233,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 355 + Math.sqrt(25 / 26 * Math.pow(40, 2)),
              yStart: 75 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2)),
              xEnd: 425 + Math.sqrt(25 / 26 * Math.pow(40, 2)),
              yEnd: 425 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2))
            },
            corner: {
              start: (355 + Math.sqrt(25 / 26 * Math.pow(40, 2))) + ',' + (75 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2))) + ' ' + (355 + Math.sqrt(25 / 26 * Math.pow(40, 2)) - 5) + ',' + (65 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2))) + ' ' + (355 + Math.sqrt(25 / 26 * Math.pow(40, 2)) + 5) + ',' + (65 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2))),
              rotateStart: 'rotate(169,' + (355 + Math.sqrt(25 / 26 * Math.pow(40, 2))) + ',' + (75 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2))) + ')',
              end: (425 + Math.sqrt(25 / 26 * Math.pow(40, 2))) + ',' + (425 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2))) + ' ' + (425 + Math.sqrt(25 / 26 * Math.pow(40, 2)) - 5) + ',' + (425 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2)) + 10) + ' ' + (425 + Math.sqrt(25 / 26 * Math.pow(40, 2)) + 5) + ',' + (425 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2)) + 10),
              rotateEnd: 'rotate(169,' + (425 + Math.sqrt(25 / 26 * Math.pow(40, 2))) + ',' + (425 - 1 / 5 * Math.sqrt(25 / 26 * Math.pow(40, 2))) + ')'
            }
          },
          id: 4
        }
      }
    }
  }
}
</script>

<style>
</style>
